export default "__VITE_ASSET__ClVw$3pI__"